import React from "react";
import { faceIcon } from "../../constants/Images";

export default function AtmCardForm(props) {
  const { handleShowcardForm } = props;
  return (
    <form action="" className="form">
      <div className="row align-items-center">
        <div className="px-3">
          <img src={faceIcon} alt="" width="40" />
        </div>
        <div>
          <h3 className="rs_h3 m-0">Card ending in ****0777</h3>
        </div>
      </div>
      <div className="form-group mb-0">
        <label className="form-label">Name on card</label>
        <input type="text" className="form-control" />
      </div>
      <div className="row gutters-5">
        <div className="col-7">
          <div className="form-group mb-0">
            <label className="form-label">Card number</label>
            <input type="text" className="form-control" />
          </div>
        </div>
        <div className="col">
          <div className="form-group mb-0">
            <label className="form-label">&nbsp;</label>
            <input type="text" className="form-control" placeholder="MM/YY" />
          </div>
        </div>
        <div className="col">
          <div className="form-group mb-0">
            <label className="form-label">&nbsp;</label>
            <input type="text" className="form-control" placeholder="CVC" />
          </div>
        </div>
      </div>
      <div className="form-group">
        <label className="form-label">Bill To</label>
        <input type="text" className="form-control" />
      </div>
      <div className="form-group">
        <label className="form-label">Country</label>
        <select name="" className="form-control select_arrow_gray">
          <option value="">USA</option>
          <option value="">India</option>
        </select>
      </div>
      <div className="form-group mb-0">
        <label className="form-label">Address</label>
        <input type="text" className="form-control" />
      </div>
      <div className="row gutters-5">
        <div className="col-6">
          <div className="form-group mb-0">
            <label className="form-label">City</label>
            <input type="text" className="form-control" />
          </div>
        </div>
        <div className="col-6">
          <div className="form-group mb-0">
            <label className="form-label">State</label>
            <input type="text" className="form-control" />
          </div>
        </div>
      </div>
      <div className="row gutters-5">
        <div className="col-6">
          <div className="form-group mb-0">
            <label className="form-label">Postal code</label>
            <input type="text" className="form-control" />
          </div>
        </div>
        <div className="col-6">
          <div className="form-group mb-0">
            <label className="form-label">Vat</label>
            <input type="text" className="form-control" />
          </div>
        </div>
      </div>
      <div className="form-group mt-5">
        <button type="submit" className="submit-btn submit-primary mt-0">
          Save Changes
        </button>
        <button
          type="submit"
          className="submit-btn submit-white"
          onClick={handleShowcardForm}
        >
          Cancel
        </button>
      </div>
    </form>
  );
}
